
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.476 2.133h-4.785V1.6c0-.882-.71-1.6-1.582-1.6H6.891c-.873 0-1.582.718-1.582 1.6v.533H.527A.532.532 0 000 2.667V14.4c0 .882.71 1.6 1.582 1.6h14.836C17.29 16 18 15.282 18 14.4V2.678v-.002c-.02-.35-.233-.54-.524-.543zM6.363 1.6c0-.294.237-.533.528-.533h4.218c.291 0 .528.239.528.533v.533H6.363V1.6zm10.378 1.6l-1.638 4.969a.527.527 0 01-.5.364h-2.966V8a.53.53 0 00-.528-.533H6.891A.53.53 0 006.363 8v.533H3.397a.527.527 0 01-.5-.364L1.259 3.2h15.482zm-6.159 5.333V9.6H7.418V8.533h3.164zm6.363 5.867a.531.531 0 01-.527.533H1.582a.531.531 0 01-.527-.533V5.953l.841 2.553a1.581 1.581 0 001.5 1.094h2.967v.533a.53.53 0 00.528.534h4.218a.53.53 0 00.528-.534V9.6h2.966c.682 0 1.285-.44 1.5-1.094l.842-2.553V14.4z"}})])
          )
        }
      }
    